export enum FuelPricingCodeFrequency {
    MONTHLY = 'MONTHLY',
    DAILY = 'DAILY',
    INTRADAY = 'INTRADAY',
}
